import { render, staticRenderFns } from "./RestaurantTabView.vue?vue&type=template&id=12cc492c&scoped=true&"
import script from "./RestaurantTabView.vue?vue&type=script&lang=js&"
export * from "./RestaurantTabView.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantTabView.vue?vue&type=style&index=0&id=12cc492c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cc492c",
  null
  
)

export default component.exports